export default __webpack_public_path__ + "bml-characteristic1.16b5785.png";